/* eslint-disable no-lonely-if */
import React from 'react';
import ReloadButton from '../../../features/ReloadButton/ReloadButton';
import Button from '../../../utils/Button';
import { InputFieldSearch, SelectOption, addOption } from '../../../utils/InputField';
import { TextCapitalize } from '../../../utils/TextFormatter';
import { useSupportTicket } from '../SupportTicketProvider';

function PageHeaderLeftCol({ handleChangeFilterData, p }) {
    return (
        <div
            // onSubmit={handleOnEnter}
            className="support_page_header_left_col flex-1 flex flex-row items-center gap-x-2 md:gap-x-4"
        >
            <InputFieldSearch
                label="Search by id, customer name, subject, last message..."
                name="q"
                onChange={handleChangeFilterData}
                formData={p}
                className="w-72 rounded-xl"
            />
            <SelectOption
                name="department"
                placeholder="Department"
                formData={p}
                onChange={handleChangeFilterData}
                options={['billing', 'technical', 'other']?.map((key) =>
                    addOption(key, TextCapitalize(key), key)
                )}
                className="w-44 rounded-xl"
            />

            <SelectOption
                name="status"
                placeholder="Status"
                formData={p}
                onChange={handleChangeFilterData}
                options={['Open', 'Closed']?.map((d) => addOption(d, d, d?.toLowerCase()))}
                className="w-38 rounded-xl"
            />
        </div>
    );
}

function PageHeaderRightCol() {
    const { openModal, handleReload } = useSupportTicket();
    return (
        <div className="customer_page_header_right_col flex-1 flex flex-row gap-2 justify-end items-center ">
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
            <Button onClick={() => openModal('add-issue')} title="+ Issue Ticket" />
        </div>
    );
}

function SupportTicketHeader({ handleChangeFilterData, p }) {
    return (
        <div className="support_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol handleChangeFilterData={handleChangeFilterData} p={p} />
            <PageHeaderRightCol />
        </div>
    );
}

export default SupportTicketHeader;
